import { Navigate, useParams } from "react-router-dom";
import { TenantEmailSettings } from "@/components/tenant-email-settings";
import { useAuthStore } from "@/stores/authStore";

export function TenantAdminEmailPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }

  if (user?.role !== "tenant_admin") {
    return <Navigate to={`/t/${tenantSlug}/dashboard`} replace />;
  }

  return (
    <main className="mx-auto max-w-3xl px-4 py-10">
      <TenantEmailSettings />
    </main>
  );
}
